import { Button, ICON_COLOR } from '@zep-us/zus';
import { XSmallIcon } from '@zep-us/zus/icons';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { type AiBuilderMessage, useAiBuilderChatActions } from '../store';
type AiBuilderChoiceMessage = Extract<AiBuilderMessage, {
  kind: 'choice';
}>;
export const AiBuilderSelectedChoiceChips = ({
  message
}: {
  message: AiBuilderChoiceMessage;
}) => {
  const {
    selectChoiceOption
  } = useAiBuilderChatActions();
  const copy = useAiBuilderChatCopy();
  const selectedOptionIdSet = new Set(message.selectedOptionIds);
  const selectedOptions = message.options.filter(option => selectedOptionIdSet.has(option.id));
  if (selectedOptions.length === 0) return null;
  return <div className="flex min-w-0 max-w-full flex-wrap items-start gap-xs" data-sentry-component="AiBuilderSelectedChoiceChips" data-sentry-source-file="AiBuilderSelectedChoiceChips.tsx">
      {selectedOptions.map(option => <Button key={option.id} type="button" variant="outlined" intent="neutral" size="xs" rounded="default" className="max-w-[180px] overflow-hidden border border-opacity-assistive bg-neutral text-caption-lg-semibold" aria-label={copy.selectedChoice.clearAriaLabel(option.label)} rightSlot={<XSmallIcon size="xs" fill={ICON_COLOR.neutral} aria-hidden="true" />} onClick={() => selectChoiceOption(message.id, option.id)}>
          <span className="min-w-0 truncate">{option.label}</span>
        </Button>)}
    </div>;
};